var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1821 11.82L20.0288 11.6C19.7605 11.26 19.4442 10.99 19.08 10.79C18.5913 10.5 18.0355 10.35 17.4605 10.35H5.5292C4.9542 10.35 4.40795 10.5 3.90962 10.79C3.53587 11 3.20045 11.29 2.92254 11.65C2.37629 12.38 2.11754 13.28 2.20379 14.18L2.55837 18.85C2.68295 20.26 2.84587 22 5.88379 22H17.1155C20.1534 22 20.3067 20.26 20.4409 18.84L20.7955 14.19C20.8817 13.35 20.6709 12.51 20.1821 11.82ZM13.79 17.34H9.19962C8.82587 17.34 8.52879 17.02 8.52879 16.64C8.52879 16.26 8.82587 15.94 9.19962 15.94H13.79C14.1638 15.94 14.4609 16.26 14.4609 16.64C14.4609 17.03 14.1638 17.34 13.79 17.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7018 8.57854C19.7389 8.9653 19.3151 9.22226 18.9469 9.09803C18.4767 8.93934 17.9826 8.86 17.4695 8.86H5.5287C5.01121 8.86 4.50145 8.94475 4.024 9.10657C3.66013 9.22989 3.23828 8.9813 3.23828 8.5971V6.66C3.23828 3.09 4.28286 2 7.70411 2H8.83495C10.2054 2 10.6366 2.46 11.1924 3.21L12.3424 4.81C12.582 5.15 12.5916 5.17 13.0133 5.17H15.2941C18.2826 5.17 19.4546 6.00338 19.7018 8.57854Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.2b8834296dcc2b342bfa199f95120a9e.svg";
export { ForwardRef as ReactComponent };